import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["climberSelect", "climbersList", "addClimberButton"]

    declare readonly climberSelectTarget: HTMLSelectElement
    declare readonly climbersListTarget: HTMLElement
    declare readonly addClimberButtonTarget: HTMLButtonElement

    connect() {
        this.onSelectChange()
        this.climberSelectTarget.addEventListener('change', () => {
            this.onSelectChange()
        })
    }

    addClimber(event: Event): void {
        event.preventDefault()

        const select = this.climberSelectTarget
        const selectedOption = select.options[select.selectedIndex]

        if (!selectedOption.value) {
        }

        const climberId: string = selectedOption.value
        const climberName: string = selectedOption.text

        if (!this.climberAlreadyAdded(climberId)) {
            this.addClimberToList(climberId, climberName)
        }
        select.selectedIndex = 0
        this.onSelectChange()
    }

    onSelectChange(): void {
        this.addClimberButtonTarget.disabled = this.climberSelectTarget.selectedIndex === 0
    }

    removeClimber(event: Event): void {
        event.preventDefault()
        const select = this.climberSelectTarget
        const button = event.currentTarget as HTMLButtonElement
        const listItem = button.closest('li')

        if (listItem) {
            listItem.remove()
        }
        select.selectedIndex = 0
        this.onSelectChange()
    }

    private climberAlreadyAdded(climberId: string): boolean {
        const list = this.climbersListTarget.querySelector('#climbers-list')
        if (!list) return false

        const existingItem = list.querySelector(`[data-climber-id="${climberId}"]`)
        return existingItem !== null
    }

    private addClimberToList(climberId: string, climberName: string): void {
        const list = this.climbersListTarget.querySelector('#climbers-list')
        if (!list) return

        const listItem = document.createElement('li')
        listItem.className = 'list-none flex -ml-6 items-center gap-4'
        listItem.setAttribute('data-climber-id', climberId)

        listItem.innerHTML = `
      <input type="hidden" name="climb[first_ascent_climber_ids][]" value="${this.escapeHtml(climberId)}">
      <button type="button"
                   class="d-btn d-btn-warning text-white cursor-pointer hover:scale-105 w-6"
                  data-action="click->climbers-manager#removeClimber"
              data-climber-id="${this.escapeHtml(climberId)}">x</button>
      ${this.escapeHtml(climberName)}`
        list.appendChild(listItem)
    }

    private escapeHtml(text: string): string {
        const div = document.createElement('div')
        div.textContent = text
        return div.innerHTML
    }
}
